"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import UserLoginLimit from "@/views/teamItems/components/dialog/UserLoginLimit.vue";
import DateFormat from "@/framework/timeformatter";
import { Debounce } from "vue-debounce-decorator";
const _gridController = new GridController(
  new APIDataSource("api://base.auth/api/v8/users")
);
let TeamLoginController = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.search_input = "";
    this.gridController = _gridController;
    this.formatter = DateFormat;
    this.searchParams = {
      search: {},
      select: null
    };
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      if (this.$route.query.hasOwnProperty("device_name")) {
        this.search_input = this.$route.query.device_name;
        this.searchParams = {
          search: {
            name: this.$route.query.device_name
          }
        };
        this.gridController.query.params = this.searchParams;
        yield this.gridController.search();
      } else {
        this.searchParams = {
          search: {}
        };
        this.gridController.query.params = this.searchParams;
        yield this.gridController.search();
      }
    });
  }
  selectItems() {
    return __async(this, null, function* () {
    });
  }
  gridSort() {
    return __async(this, null, function* () {
    });
  }
  formatDepartment(data) {
    let arr = [];
    for (let item of data) {
      arr.push(item.name);
    }
    return arr.join(",");
  }
  refresh() {
    return __async(this, null, function* () {
      this.gridController.query.params = this.searchParams;
      yield this.gridController.search();
    });
  }
  searchName(name) {
    return __async(this, null, function* () {
      try {
        this.searchParams = {
          search: {
            name
          }
        };
        this.gridController.query.params = this.searchParams;
        yield this.gridController.search();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  editLimit(data) {
    return __async(this, null, function* () {
      try {
        let arr = [];
        arr.push(data);
        this._login_limit.open(arr);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("login-limit")
], TeamLoginController.prototype, "_login_limit", 2);
__decorateClass([
  Debounce(800)
], TeamLoginController.prototype, "searchName", 1);
TeamLoginController = __decorateClass([
  Component({
    components: {
      UiGrid,
      UserLoginLimit
    }
  })
], TeamLoginController);
export {
  TeamLoginController as default
};
